import axios from 'axios'
import { logIssue } from '@revbox/tracking'

const responseInterceptorConfig = {
    onFulfilled: response => response,
    onRejected: error => {
        const status = error.response?.status
        const cfg = error.config

        // 1) Silently resolve canceled requests
        if (axios.isCancel(error)) {
            return Promise.resolve()
        }

        // 2) Handle 401 — redirect if not skipped
        if (status === 401 && !cfg?.skipRedirectOn401) {
            window.location.href = '/pages/signin'
            return
        }

        // 3) Log all other errors for analytics
        const responseError = error?.response?.data || {}

        logIssue(responseError.message || 'Unknown Error', {
            error: responseError?.error,
            inputParams: responseError?.input_parameters,
            code: responseError?.code,
            type: responseError?.type
        })

        return Promise.reject(error)
    }
}

export default responseInterceptorConfig
